import {Component, Inject} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {Detalhamento} from './detalhamento';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'store-detalhamento',
    templateUrl: './detalhamento.component.html',
    styleUrls: ['./detalhamento.component.scss']
})

export class DetalhamentoComponent {

    public detalhamento: Detalhamento;

    constructor(@Inject(DOCUMENT) private document: Document, activatedRoute: ActivatedRoute) {
        this.detalhamento = activatedRoute.snapshot.data.data;
        this.document.getElementsByTagName('body')[0].className = `bg-area ${this.detalhamento.areaNegocio.estilo}`;
    }

}
